export const curr = (value: number, currency?: string, roundUp = false) => {
  if (currency) {
    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency || 'GBP',
      currencyDisplay: 'symbol',
    });
    return formatter
      .format(roundUp ? Math.ceil(value) : value)
      .replace(/\D00$/, '')
      .replace(/^[a-zA-Z]+/i, '');
  } else {
    return roundNumber(value);
  }
};

export const roundNumber = (value: number) => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    maximumFractionDigits: 2,
  });
  return formatter.format(value).replace(/\D00$/, '');
};
